<template>
  <div class="dash_temp" :title="title">{{ value }}<span class="dash_unit">{{ unit }}</span></div>
</template>
<script>
export default {
  props: {
    value: { type: String, default: "" },
    unit: { type: String, default: "" },
    title: { type: String, default: "" },

  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
<style scoped>
.dash_temp {
  display: inline-block;
  cursor: pointer;
  color: #2a7aff;
  background-size: cover;
  float: left;
  font-size: 24px;
  margin-right: 20px;
  font-weight: 600;
  display: flex;
  align-items: flex-end;
}

.dash_unit {
  font-size: 12px;
}
</style>
